'use client'

import Script from 'next/script'
import { META_PIXEL_ID, DEBUG } from '@/lib/config'

/**
 * MetaPixel Component
 *
 * Loads the Meta (Facebook) Pixel for ads measurement / Events Manager.
 * Renders the base init + PageView track, plus a noscript image fallback.
 */
export default function MetaPixel() {
  if (DEBUG) {
    console.log('[Meta Pixel] ID:', META_PIXEL_ID || 'missing')
  }

  if (!META_PIXEL_ID) {
    if (DEBUG) {
      console.warn(
        'Meta Pixel ID missing - Meta Pixel disabled. ' +
          'Set NEXT_PUBLIC_META_PIXEL_ID in your .env.local file.'
      )
    }
    return null
  }

  return (
    <>
      <Script id="meta-pixel" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${META_PIXEL_ID}');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  )
}
